'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//  weak
var AsynchResponders = function () {
    function AsynchResponders() {
        (0, _classCallCheck3.default)(this, AsynchResponders);

        this._responders = [];
    }

    // PUBLIC API


    (0, _createClass3.default)(AsynchResponders, [{
        key: 'getLength',
        value: function getLength() {
            return this._responders.length;
        }
    }, {
        key: 'isBusy',
        value: function isBusy() {
            return this.getLength() > 0;
        }
    }, {
        key: 'hasResponder',
        value: function hasResponder(responder) {
            return this._responders.indexOf(responder) !== -1;
        }
    }, {
        key: 'addResponder',
        value: function addResponder(responder) {
            this._responders.push(responder);
        }
    }, {
        key: 'addResponders',
        value: function addResponders(additionalRespondersArray) {
            if (additionalRespondersArray && additionalRespondersArray instanceof Array && additionalRespondersArray.length) {
                this._responders = this._responders.concat(additionalRespondersArray);
            }
        }
    }, {
        key: 'takeOutResponder',
        value: function takeOutResponder(responder) {
            var index = this._responders.indexOf(responder);
            if (index !== -1) {
                this._responders.splice(index, 1);
                return true;
            }

            return false;
        }
    }, {
        key: 'reset',
        value: function reset() {
            if (this._responders.length > 0) {
                console.warn('Resetting too early? Still have responders marked for asynchronous tasks');
            }

            this._responders = [];
        }
    }]);
    return AsynchResponders;
}();

exports.default = AsynchResponders;
//# sourceMappingURL=AsynchResponders.js.map